import { event } from 'jquery';
import React,{useState,useEffect} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';
import SideMenu from '../../utilities/sideMenu/menu'
import MedicalHistory from '../demographics/medicalHistory'
function AnswerField(props){
    const [status,setStatus] = useState(props.data!=null?true:false)
   const [value,setValue] = useState(props.data!=null?props.data:"")// setting state depending if its a new visit or a new patient
//    const [previous,setPrev] = useState(props.data!=null?props.data:"")
    const onChange=(event)=>{
        setValue(event.target.value)
        if (event.target.value === 'No' && props.score_p === 0) {
            props.score(1)
            setStatus(true)
        } else if (event.target.value === 'Yes' && props.score_p === 1) {
            props.score(1)
            setStatus(true)
        } else {
            if (status) {
                props.score(-1)
                setStatus(false)
            }
        }
        
        props.handler(event)
    }
    return(
   
    <Form.Group as={Col}>
            
            <Form.Control as={"select"} onChange={onChange} name={props.name} value={value} disabled={props.disabled}>
                    <option></option>
                    <option>Yes</option>
                    <option>No</option>
            </Form.Control>
         </Form.Group>
  
    )
}
AnswerField.defaultProps ={
    data:null
}




class GDS extends React.Component {
    constructor(props) {
        super(props)
        this.state ={score:0}
        this.Scoring = this.Scoring.bind(this)
        
    }
    questions = [
        ["Are you basically satisfied with your life?",0], //yes
        ["Have you dropped many of your activities and interests?",1], //
        ["Do you feel that your life is empty?",1],
        ["Do you often get bored?",1],
        ["Are you in good spirits most of the time?",0],
        ["Are you afraid that something bad is going to happen to you?",1],
        ["Do you feel happy most of the time?",0],
        ["Do you often feel helpless?",1],
       [ "Do you prefer to stay at home, rather than going out and doing things?",1],
        ["Do you feel that you have more problems with  memory than most?",1],
        ["Do you think it is wonderful to be alive now?",0],
        ["Do you feel worthless the way you are now?",1],
        ["Do you feel full of energy?",0],
        ["Do you feel that your situation is hopeless?",1],
        ["Do you think that most people are better off than you are?",1]


    ]
   
    


    Scoring = async (val)=> {
       
            await this.setState((prevState) => 
                    ({
                        ...prevState,
                        score:prevState.score + (val)

                    })
                    
            )
        
        
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    componentDidUpdate(prevProps,prevState){
        if(prevState != this.state ){
           this.props.handler('gds',this.state)
        }
    }
    onChange = async (event) => {
        const {name,value} = event.target
        
      await  this.setState((prevState)=>({
            ...prevState,
            
           
                [name]:value
            
        }))
    //      await this.props.handler('gds',this.state)
    
    }
    render() {
        return(
            <div> 
              
             <Container>
                <h3 style={{textAlign:'center'}}>Geriatric Depression Scale</h3>
                <br/>
                <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {this.questions.map((items,index ) =>
                            <tr key={index}>
                                <th><p>{index+1}.{items[0]}</p></th>
                                <th>{this.props.data!=null?<AnswerField name={index+1} handler={this.onChange} score_p={items[1]}score={this.Scoring} data={this.props.data[index+1]} disabled={this.props.disabled} />:
                                <AnswerField name={index+1} handler={this.onChange} score_p={items[1] }score={this.Scoring} />
                                 }</th>
                                {/* <th>{this.AnswerField()}</th> */}
                            </tr>
                        )}
                    </tbody>
                    <thead>
                        <tr>
                            <th>Total Score</th>
                            <th>{this.state.score}</th>
                        </tr>
                    </thead>
                
                
                </Table>

            </Container>
            </div>
    )
    }
}
GDS.defaultProps = {
    data:null,
    disabled:false
}

export default GDS;